import React from 'react'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'

const ReportsTrialAlert = (): React.ReactNode => (
  <Alert icon="warning" status="warning">
    Reports let you generate{' '}
    <InlineLink
      to="https://support.disco.ac/home/insights-guide#generating-reports"
      target="_blank"
      rel="noopener noreferrer"
    >
      powerful insights
    </InlineLink>{' '}
    on your activity in DISCO. Reports are available on{' '}
    <InlineLink to="/settings/billing">Plus and Pro plans.</InlineLink>
  </Alert>
)

export default ReportsTrialAlert
